import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import IDUploadModal from './IDUploadModal';
import WhiteSquare from '../../WhiteSquare';

const ShowModalButton = styled.a`
  background: none;
  border: none;
  height: 140px;
  padding: 0;
  margin: 0;
  width: 140px;
`;

const Description = styled.small`
  ${themes.fonts.FoundersGrotesk};
  max-width: 140px;
  display: inline-block;
  text-align: center;
  margin: 8px 0 0 0;
`;

type Props = {};
type State = {
  showingModal: boolean;
};

export default class InsuranceCardUploadButton extends Component<Props, State> {
  state = { showingModal: false };

  showModal = () => {
    this.setState({ showingModal: true });
  };

  render() {
    const { showingModal } = this.state;
    const body = document.body;
    if (!body) return null;

    return (
      <Fragment>
        <ShowModalButton onClick={this.showModal}>
          <WhiteSquare />
        </ShowModalButton>
        {showingModal &&
          ReactDOM.createPortal(
            <IDUploadModal
              onClose={() => {
                this.setState({ showingModal: false });
              }}
            />,
            body
          )}
        <Description>
          PDF, JPEG, JPG and PNG file types are allowed. The maximum file size is 2 MB.
        </Description>
      </Fragment>
    );
  }
}
